import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import MetricsCard from './MetricsCard';

const EventPromotionsPanel = () => {
  const [events, setEvents] = useState([
    {
      id: 1,
      title: 'Summer Wedding Expo 2025',
      type: 'exhibition',
      status: 'active',
      startDate: '2025-08-15T10:00:00Z',
      endDate: '2025-08-17T18:00:00Z',
      location: 'Mumbai Convention Center',
      registrations: 245,
      maxCapacity: 500,
      featured: true,
      description: 'Join us for the biggest wedding exhibition of the year featuring top vendors.'
    },
    {
      id: 2,
      title: 'Monsoon Wedding Special',
      type: 'promotion',
      status: 'scheduled',
      startDate: '2025-07-20T00:00:00Z',
      endDate: '2025-09-30T23:59:59Z',
      location: 'Online',
      registrations: 0,
      maxCapacity: null,
      featured: false,
      description: 'Special discounts and offers for monsoon weddings from verified vendors.'
    },
    {
      id: 3,
      title: 'Bridal Fashion Week',
      type: 'workshop',
      status: 'completed',
      startDate: '2025-06-01T10:00:00Z',
      endDate: '2025-06-07T18:00:00Z',
      location: 'Delhi Fashion Hub',
      registrations: 180,
      maxCapacity: 200,
      featured: false,
      description: 'Fashion shows and workshops featuring latest bridal trends and designers.'
    }
  ]);

  const [promotions, setPromotions] = useState([
    {
      id: 1,
      title: 'Early Bird Discount',
      code: 'EARLY2025',
      discount: 25,
      discountType: 'percentage',
      status: 'active',
      validFrom: '2025-07-10T00:00:00Z',
      validUntil: '2025-08-10T23:59:59Z',
      usageCount: 89,
      usageLimit: 500,
      targetAudience: 'new-users'
    },
    {
      id: 2,
      title: 'Vendor Partnership Offer',
      code: 'PARTNER50',
      discount: 50,
      discountType: 'percentage',
      status: 'active',
      validFrom: '2025-07-01T00:00:00Z',
      validUntil: '2025-12-31T23:59:59Z',
      usageCount: 23,
      usageLimit: 100,
      targetAudience: 'premium-vendors'
    },
    {
      id: 3,
      title: 'Flash Sale Weekend',
      code: 'FLASH30',
      discount: 1000,
      discountType: 'fixed',
      status: 'expired',
      validFrom: '2025-07-05T00:00:00Z',
      validUntil: '2025-07-07T23:59:59Z',
      usageCount: 156,
      usageLimit: 200,
      targetAudience: 'all-users'
    }
  ]);

  const [newEvent, setNewEvent] = useState({
    title: '',
    type: 'exhibition',
    startDate: '',
    endDate: '',
    location: '',
    maxCapacity: '',
    description: ''
  });

  const [newPromotion, setNewPromotion] = useState({
    title: '',
    code: '',
    discount: '',
    discountType: 'percentage',
    validFrom: '',
    validUntil: '',
    usageLimit: '',
    targetAudience: 'all-users'
  });

  const [activeTab, setActiveTab] = useState('events');

  const eventStats = {
    totalEvents: events.length,
    activeEvents: events.filter(e => e.status === 'active').length,
    totalRegistrations: events.reduce((sum, e) => sum + e.registrations, 0),
    upcomingEvents: events.filter(e => new Date(e.startDate) > new Date()).length
  };

  const promotionStats = {
    totalPromotions: promotions.length,
    activePromotions: promotions.filter(p => p.status === 'active').length,
    totalUsage: promotions.reduce((sum, p) => sum + p.usageCount, 0),
    totalSavings: promotions.reduce((sum, p) => sum + (p.usageCount * (p.discountType === 'percentage' ? 100 : p.discount)), 0)
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-green-600 bg-green-100';
      case 'scheduled': return 'text-blue-600 bg-blue-100';
      case 'completed': return 'text-gray-600 bg-gray-100';
      case 'expired': return 'text-red-600 bg-red-100';
      case 'cancelled': return 'text-red-600 bg-red-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'exhibition': return 'text-purple-600 bg-purple-100';
      case 'promotion': return 'text-orange-600 bg-orange-100';
      case 'workshop': return 'text-blue-600 bg-blue-100';
      case 'webinar': return 'text-green-600 bg-green-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleCreateEvent = () => {
    if (newEvent.title && newEvent.startDate && newEvent.endDate) {
      const event = {
        id: Date.now(),
        ...newEvent,
        status: 'scheduled',
        registrations: 0,
        featured: false,
        maxCapacity: newEvent.maxCapacity ? parseInt(newEvent.maxCapacity) : null
      };
      setEvents(prev => [event, ...prev]);
      setNewEvent({
        title: '',
        type: 'exhibition',
        startDate: '',
        endDate: '',
        location: '',
        maxCapacity: '',
        description: ''
      });
    }
  };

  const handleCreatePromotion = () => {
    if (newPromotion.title && newPromotion.code && newPromotion.discount) {
      const promotion = {
        id: Date.now(),
        ...newPromotion,
        status: 'active',
        usageCount: 0,
        discount: parseFloat(newPromotion.discount),
        usageLimit: newPromotion.usageLimit ? parseInt(newPromotion.usageLimit) : null
      };
      setPromotions(prev => [promotion, ...prev]);
      setNewPromotion({
        title: '',
        code: '',
        discount: '',
        discountType: 'percentage',
        validFrom: '',
        validUntil: '',
        usageLimit: '',
        targetAudience: 'all-users'
      });
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          Event & Promotions Manager
        </h2>
        <p className="text-orange-100">
          Organize events and manage promotional campaigns
        </p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {activeTab === 'events' ? (
          <>
            <MetricsCard
              title="Total Events"
              value={eventStats.totalEvents}
              icon="Calendar"
              color="blue"
            />
            <MetricsCard
              title="Active Events"
              value={eventStats.activeEvents}
              icon="Play"
              color="green"
            />
            <MetricsCard
              title="Total Registrations"
              value={eventStats.totalRegistrations}
              icon="Users"
              color="purple"
            />
            <MetricsCard
              title="Upcoming"
              value={eventStats.upcomingEvents}
              icon="Clock"
              color="orange"
            />
          </>
        ) : (
          <>
            <MetricsCard
              title="Total Promotions"
              value={promotionStats.totalPromotions}
              icon="Tag"
              color="blue"
            />
            <MetricsCard
              title="Active"
              value={promotionStats.activePromotions}
              icon="Zap"
              color="green"
            />
            <MetricsCard
              title="Total Usage"
              value={promotionStats.totalUsage}
              icon="TrendingUp"
              color="purple"
            />
            <MetricsCard
              title="Total Savings"
              value={`₹${promotionStats.totalSavings.toLocaleString()}`}
              icon="DollarSign"
              color="orange"
            />
          </>
        )}
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-xl shadow-soft">
        <div className="flex border-b border-gray-200">
          <button
            onClick={() => setActiveTab('events')}
            className={`px-6 py-4 font-medium ${
              activeTab === 'events' ?'text-primary border-b-2 border-primary' :'text-gray-500 hover:text-gray-700'
            }`}
          >
            Events
          </button>
          <button
            onClick={() => setActiveTab('promotions')}
            className={`px-6 py-4 font-medium ${
              activeTab === 'promotions' ?'text-primary border-b-2 border-primary' :'text-gray-500 hover:text-gray-700'
            }`}
          >
            Promotions
          </button>
        </div>

        <div className="p-6">
          {activeTab === 'events' && (
            <div>
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-heading font-semibold text-xl text-text-primary">
                  Events Management
                </h3>
                <Button variant="primary">
                  <Icon name="Plus" size={16} className="mr-2" />
                  New Event
                </Button>
              </div>

              {/* Create New Event Form */}
              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <h4 className="font-medium text-gray-900 mb-4">Create New Event</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Event Title"
                    value={newEvent.title}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, title: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <select
                    value={newEvent.type}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, type: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  >
                    <option value="exhibition">Exhibition</option>
                    <option value="workshop">Workshop</option>
                    <option value="webinar">Webinar</option>
                    <option value="promotion">Promotion</option>
                  </select>
                  <input
                    type="datetime-local"
                    placeholder="Start Date"
                    value={newEvent.startDate}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, startDate: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="datetime-local"
                    placeholder="End Date"
                    value={newEvent.endDate}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, endDate: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="text"
                    placeholder="Location"
                    value={newEvent.location}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, location: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="number"
                    placeholder="Max Capacity (Optional)"
                    value={newEvent.maxCapacity}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, maxCapacity: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <textarea
                    placeholder="Event Description"
                    value={newEvent.description}
                    onChange={(e) => setNewEvent(prev => ({ ...prev, description: e.target.value }))}
                    className="md:col-span-2 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    rows={3}
                  />
                  <div className="md:col-span-2 flex justify-end">
                    <Button variant="primary" onClick={handleCreateEvent}>
                      <Icon name="Plus" size={16} className="mr-2" />
                      Create Event
                    </Button>
                  </div>
                </div>
              </div>

              {/* Events List */}
              <div className="space-y-4">
                {events.map((event) => (
                  <div key={event.id} className="border border-gray-200 rounded-lg p-6">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <h4 className="font-medium text-text-primary">{event.title}</h4>
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${getTypeColor(event.type)}`}>
                            {event.type}
                          </span>
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(event.status)}`}>
                            {event.status}
                          </span>
                          {event.featured && (
                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
                              Featured
                            </span>
                          )}
                        </div>
                        <p className="text-text-secondary mb-3">{event.description}</p>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-text-muted">
                          <div>
                            <Icon name="Calendar" size={16} className="inline mr-1" />
                            {formatDate(event.startDate)} - {formatDate(event.endDate)}
                          </div>
                          <div>
                            <Icon name="MapPin" size={16} className="inline mr-1" />
                            {event.location}
                          </div>
                          <div>
                            <Icon name="Users" size={16} className="inline mr-1" />
                            {event.registrations} registered
                            {event.maxCapacity && ` / ${event.maxCapacity} max`}
                          </div>
                        </div>
                      </div>
                      <div className="flex space-x-2 ml-4">
                        <Button variant="ghost" size="sm">
                          <Icon name="Eye" size={16} />
                        </Button>
                        <Button variant="ghost" size="sm">
                          <Icon name="Edit" size={16} />
                        </Button>
                        <Button variant="ghost" size="sm">
                          <Icon name="BarChart3" size={16} />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'promotions' && (
            <div>
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-heading font-semibold text-xl text-text-primary">
                  Promotional Campaigns
                </h3>
                <Button variant="primary">
                  <Icon name="Plus" size={16} className="mr-2" />
                  New Promotion
                </Button>
              </div>

              {/* Create New Promotion Form */}
              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <h4 className="font-medium text-gray-900 mb-4">Create New Promotion</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Promotion Title"
                    value={newPromotion.title}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, title: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="text"
                    placeholder="Promo Code"
                    value={newPromotion.code}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, code: e.target.value.toUpperCase() }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="number"
                    placeholder="Discount Value"
                    value={newPromotion.discount}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, discount: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <select
                    value={newPromotion.discountType}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, discountType: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  >
                    <option value="percentage">Percentage (%)</option>
                    <option value="fixed">Fixed Amount (₹)</option>
                  </select>
                  <input
                    type="datetime-local"
                    placeholder="Valid From"
                    value={newPromotion.validFrom}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, validFrom: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="datetime-local"
                    placeholder="Valid Until"
                    value={newPromotion.validUntil}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, validUntil: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <input
                    type="number"
                    placeholder="Usage Limit (Optional)"
                    value={newPromotion.usageLimit}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, usageLimit: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  <select
                    value={newPromotion.targetAudience}
                    onChange={(e) => setNewPromotion(prev => ({ ...prev, targetAudience: e.target.value }))}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  >
                    <option value="all-users">All Users</option>
                    <option value="new-users">New Users</option>
                    <option value="premium-vendors">Premium Vendors</option>
                    <option value="returning-customers">Returning Customers</option>
                  </select>
                  <div className="md:col-span-2 flex justify-end">
                    <Button variant="primary" onClick={handleCreatePromotion}>
                      <Icon name="Plus" size={16} className="mr-2" />
                      Create Promotion
                    </Button>
                  </div>
                </div>
              </div>

              {/* Promotions List */}
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Promotion
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Code
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Discount
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Usage
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {promotions.map((promotion) => (
                      <tr key={promotion.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4">
                          <div>
                            <div className="font-medium text-gray-900">{promotion.title}</div>
                            <div className="text-sm text-gray-500">
                              Valid: {formatDate(promotion.validFrom)} - {formatDate(promotion.validUntil)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <code className="px-2 py-1 bg-gray-100 rounded text-sm font-mono">
                            {promotion.code}
                          </code>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {promotion.discountType === 'percentage' ? `${promotion.discount}%` : `₹${promotion.discount}`}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(promotion.status)}`}>
                            {promotion.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {promotion.usageCount}
                          {promotion.usageLimit && ` / ${promotion.usageLimit}`}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                          <Button variant="ghost" size="sm">
                            <Icon name="Edit" size={16} />
                          </Button>
                          <Button variant="ghost" size="sm">
                            <Icon name="BarChart3" size={16} />
                          </Button>
                          <Button variant="ghost" size="sm">
                            <Icon name="Copy" size={16} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventPromotionsPanel;